import useIsMobile from '@/hooks/useIsMobile';
import OrderSummaryCardDesktop from './desktop';
import OrderSummaryCardMobile from './mobile';

const OrderSummaryCard = () => {
    const isMobile = useIsMobile(992);
    return isMobile ? <OrderSummaryCardMobile /> : <OrderSummaryCardDesktop />;
};

export default OrderSummaryCard;
